import React, { useEffect, useState } from "react";
import moment from "moment";
import AlignerImage from "./../assets/aligner.png";
import { useNavigate } from "react-router";
import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  TERTIARY_COLOR,
} from "../constants/theme";
import { toast } from "react-toastify";
import { getPatientCaseData } from "../services/patient/patient.service";
import Loader from "../components/Loader";

const CaseScreen = () => {
  const navigate = useNavigate();

  const [screenWidth, setScreenWidth] = useState(0);
  const email = sessionStorage.getItem("email");
  const clinic = JSON.parse(sessionStorage.getItem("clinicCode") || "[]");
  let clinicCode = undefined;
  if (clinic.length > 0) {
    clinicCode = clinic[0].clinic_code;
  }

  const patientId = sessionStorage.getItem("patientId");

  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  console.log(screenWidth);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const getPatientCases = async () => {
    try {
      setLoading(true);

      if (!clinicCode) {
        return toast.error("No associated clinic found. Contact support!");
      }
      if (!patientId) {
        toast.error("Data error! Login again!");
        sessionStorage.clear();
        navigate("/login");
        return;
      }
      const response = await getPatientCaseData(email, patientId, 100, page);
      if (response.status === 200) {
        setCases(response.data.data);
        setTotalPages(response?.data?.page_info?.totalPages);
        setPage(response?.data?.page_info?.page);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("ERROR FETCHING PATIENT CASE DATA => ", error);
      return toast("Server error. Try again later!");
    }
  };

  const getPatientCasesOtherPages = async () => {
    try {
      setLoading(true);

      if (!clinicCode) {
        return toast.error("No associated clinic found. Contact support!");
      }
      if (!patientId) {
        toast.error("Data error! Login again!");
        sessionStorage.clear();
        navigate("/login");
        return;
      }
      const response = await getPatientCaseData(email, patientId, 100, page);
      if (response.status === 200) {
        let prevCases = [];
        if (cases && cases.length > 0) {
          prevCases = [...cases];
        }
        prevCases = [...prevCases, ...response?.data?.data];
        setCases(prevCases);
        setTotalPages(response?.data?.page_info?.totalPages);
        setPage(response?.data?.page_info?.page);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("ERROR FETCHING PATIENT CASE DATA => ", error);
      return toast("Server error. Try again later!");
    }
  };

  useEffect(() => {
    getPatientCases();
  }, []);

  useEffect(() => {
    if (page > 1) {
      getPatientCasesOtherPages();
    }
  }, [page]);

  return (
    <div className="position-relative col-12 p-0" style={{ zIndex: "20" }}>
      <div className="row w-100 mx-auto flex-column align-items-center justify-content-between">
        <div className="col-12 p-0">
          <div
            className=""
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              // padding: "13px 13px 32px 13px",
              marginLeft: "10px",
              marginRight: "10px",
              borderRadius: "15px",
              overflowY: "scroll",
              height: "90vh",
              scrollBehavior: "smooth",
              // minHeight: "780px",
            }}
          >
            {/* <div className="d-flex justify-content-center text-center">
              <h4
                className="text-center mt-2"
                style={{
                  color: HEADER_COLOR,
                }}
              >
                Cases
              </h4>
            </div>
            <hr /> */}
            <div
              className="row w-100 mx-auto"
              style={{
                marginTop: "18px",
                lineHeight: "1.1",
                gap: "22px",
              }}
            >
              {loading && <Loader />}
              {!loading && cases && cases.length === 0 && (
                <div>No data found!</div>
              )}
              {!loading &&
                cases &&
                cases.length > 0 &&
                cases.map((item, index) => {
                  return (
                    <div className="col-12 px-sm-4" key={index}>
                      <div
                        className="mx-auto card-hover-effect"
                        style={{
                          padding: "14px 6px 14px 14px",
                          backgroundColor: "rgb(203, 108, 230)",
                          borderRadius: "16px",
                          gap: "12px",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: screenWidth <= 480 ? "column" : "",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          textAlign: "center",
                        }}
                        onClick={(e) => {
                          sessionStorage.setItem("case", JSON.stringify(item));
                          navigate("/view-case");
                        }}
                      >
                        <div
                          className={`col-${
                            screenWidth <= 480
                              ? "12 d-flex justify-content-center"
                              : "auto"
                          } p-0`}
                        >
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              height: "50px",
                              width: "50px",
                            }}
                          >
                            <img
                              className="w-100"
                              src={AlignerImage}
                              alt="aligner"
                              style={{}}
                            />
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            {/* <div className="" style={{}}>
                              {item?.case_id}
                            </div> */}
                            <div
                              className=""
                              style={{
                                fontSize: "10px",
                                lineHeight: "1.25",
                              }}
                            >
                              {item?.current_status}
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            <div className="" style={{}}>
                              {item?.service && item?.service === "both"
                                ? "TP / FAB"
                                : item?.service.toUpperCase()}
                            </div>
                            <div
                              className=""
                              style={{
                                fontSize: "10px",
                                lineHeight: "1.25",
                              }}
                            >
                              {moment(item?.updated_at).format(
                                "DD MMM YY HH:MM A"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {page !== totalPages && (
                <div className="d-flex w-100 justify-content-center align-items-center">
                  <button
                    className="btn p-2"
                    style={{
                      backgroundColor: PRIMARY_COLOR,
                      color: TERTIARY_COLOR,
                    }}
                    onClick={() => setPage((prev) => prev + 1)}
                  >
                    Show more
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseScreen;
